import { useState, useEffect } from 'react';
import { useAnalytics } from './useAnalytics';

/**
 * Hook to check if a feature flag is enabled.
 * Returns false while loading and if analytics is not initialized.
 */
export function useFeatureFlag(flagName: string): boolean {
  const analytics = useAnalytics();
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    let cancelled = false;
    analytics.isFeatureFlagEnabled(flagName).then((result) => {
      if (!cancelled) setEnabled(result);
    });
    return () => {
      cancelled = true;
    };
  }, [analytics, flagName]);

  return enabled;
}
